<div class="interest-late-fees-container">
  @if (isLoading) {
    <div class="spinner-overlay">
      <app-tdo-progress-spinner data-cy="interest-late-fees-spinner"></app-tdo-progress-spinner>
    </div>
  }
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title" data-cy="interest-late-fees-title">
        Interest and Late Fees
      </div>
    </div>

    <!-- MAIN AREA -->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;">
      <div style="flex: 1; overflow-y: hidden;">
        <!-- body of modal -->
        <div>
          <div class="content-wrapper">
            <!-- Left Sidebar - Filtering Options -->
            <div class="sidebar">
              <div class="filter-section">
                <h3>Practices</h3>
                <div style="width: 100%; margin-bottom: 10px">
                  <app-tdo-dropdown [hideSingleSelectionIndicator]="true"
                    style="width: 100%; margin-bottom: 10px"
                    [dataSource]="clientList"
                    dataSourceDisplayKey="Name"
                    [isObjectValue]="true"
                    [value]="selectedClient"
                    (selectionChange)="onChangeClient($event)">
                  </app-tdo-dropdown>
                </div>
              </div>

              <div class="filter-section">
                <h3>Locations *</h3>
                <div  style="width: 100%; margin-bottom: 10px">
                  <tdo-dropdown-v2
                    style="width: 100%; margin-bottom: 10px"
                    [datasource]="locationList"
                    displayProperty="Name"
                    [value]="selectedClientLocation"
                    (selectionChange)="onChangeClientLocation($event)">
                  </tdo-dropdown-v2>
                </div>
              </div>

              <div class="filter-section">
                <h3>Doctors / Providers *</h3>
                <div class="radio-group" style="overflow-y: auto; max-height: 120px;">
                  <mat-radio-group [(ngModel)]="selectedDoctor">
                    @for (doctor of doctors; track doctor) {
                      <mat-radio-button
                        [value]="doctor"
                        class="filter-radio">
                        {{ doctor.name }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              </div>

              <div class="filter-section">
                <h3>Account Status *</h3>
                <div class="radio-group">
                  <mat-radio-group [(ngModel)]="accountStatus">
                    <mat-radio-button
                      value="30"
                      class="filter-radio">
                      30 Day over and older
                    </mat-radio-button>
                    <mat-radio-button
                      value="60"
                      class="filter-radio">
                      60 Day over and older
                    </mat-radio-button>
                    <mat-radio-button
                      value="90"
                      class="filter-radio">
                      Over 90 Day
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <button type="button" mat-button class="tdo-button tdo-save show-list-btn"
                [disabled]="!canShowList()"
                (click)="onShowList()">
                Show List
              </button>
              @if (!canShowList()) {
                <div class="validation-note">
                  <small>Please select Location, Doctor, and Account Status to continue</small>
                </div>
              }
            </div>

            <!-- Main Content Area -->
            <div class="main-content">
              <!-- Global Interest and Late Fee Controls -->
              <div class="global-controls">
                <div class="control-group">
                  <label>Interest:</label>
                  <input
                    type="number"
                    [(ngModel)]="globalInterestRate"
                    class="rate-input"
                    step="0.01"
                    min="0"
                    max="100">
                    <span class="unit">%</span>
                  </div>

                  <div class="control-group">
                    <label>Late Fee:</label>
                    <input
                      type="number"
                      [(ngModel)]="globalLateFeeAmount"
                      class="rate-input"
                      step="0.01"
                      min="0">
                      <span class="unit">$</span>
                    </div>

                    <mat-checkbox
                      [(ngModel)]="selectAll"
                      [disabled]="!patientAccounts || patientAccounts.length === 0"
                      (change)="onSelectAllChange()"
                      class="select-all-checkbox">
                      Select All
                    </mat-checkbox>

                    <button type="button" mat-button class="tdo-button tdo-save"
                      [disabled]="!canApplyGlobalRates()"
                      (click)="onApplyGlobalRates()">
                      Apply
                    </button>
                    @if (apiMessage) {
                      <div class="api-message" style="margin-top: 5px; padding: 8px; border-radius: 4px;"
                     [ngClass]="{
                       'success-message': apiMessageType === 'success',
                       'error-message': apiMessageType === 'error'
                     }">
                        <small [style.color]="apiMessageType === 'success' ? '#28a745' : '#dc3545'">
                          {{ apiMessage }}
                        </small>
                      </div>
                    }
                  </div>

                  <!-- Patient Account List -->
                  @if (patientAccounts && patientAccounts.length > 0) {
                    <div class="patient-list">
                      <div class="table-header">
                        <div class="header-cell">Patient#</div>
                        <div class="header-cell">Patient Name</div>
                        <div class="header-cell">Practice</div>
                        <div class="header-cell">Total</div>
                        <div class="header-cell">Interest %</div>
                        <div class="header-cell">Interest $</div>
                        <div class="header-cell">Late Fee $</div>
                        <div class="header-cell">
                          <lucide-icon name="square-check" [size]="20"></lucide-icon>
                        </div>
                      </div>
                      <div class="patient-list-scroll">
                        @for (account of patientAccounts; track account) {
                          <div class="patient-row">
                            <div class="patient-data">
                              <div class="data-cell">{{ account.PatientNo }}</div>
                              <div class="data-cell">{{ account.PatientName }}</div>
                              <div class="data-cell">{{ account.LocationName }}</div>
                              <div class="data-cell">${{ account.Total?.toFixed(2) || '0.00' }}</div>
                              <div class="data-cell">
                                <input
                                  type="number"
                                  [(ngModel)]="account.InterestP"
                                  (ngModelChange)="onInterestPercentageChange(account)"
                                  (blur)="onInterestPercentageBlur(account)"
                                  class="cell-input"
                                  min="0"
                                  max="100">
                                </div>
                                <div class="data-cell">${{ account.InterestA?.toFixed(2) || '0.00' }}</div>
                                <div class="data-cell">
                                  <input
                                    type="number"
                                    [(ngModel)]="account.LateFee"
                                    (blur)="onLateFeeBlur(account)"
                                    class="cell-input"
                                    min="0">
                                  </div>
                                  <div class="data-cell">
                                    <mat-checkbox
                                      [(ngModel)]="account.selected"
                                      (change)="onPatientSelectionChange()">
                                    </mat-checkbox>
                                  </div>
                                </div>
                                <!-- Aging Buckets -->
                                <div class="aging-buckets">
                                  <div class="aging-box">30 Day: ${{ account.AR30Balance?.toFixed(2) || '0.00' }}</div>
                                  <div class="aging-box">60 Day: ${{ account.AR60Balance?.toFixed(2) || '0.00' }}</div>
                                  <div class="aging-box">90 Day: ${{ account.AR90Balance?.toFixed(2) || '0.00' }}</div>
                                  @if (account.LastCharged) {
                                    <div class="last-charged-box">
                                      {{ account.LastCharged }}
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }

                      <!-- No Patients Message -->
                      @if (!patientAccounts || patientAccounts.length === 0) {
                        <div class="no-patients-message">
                          <p>No patients found. Use the filters above and click "Show List" to load patients.</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- FOOTER -->
            <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;">
              <div style="flex: 1; margin-right: 6px;"></div>
              <button type="button" mat-button
                [disabled]="isLoading || !canSubmitCharges()"
                (click)="onSubmitCharges()"
                class="tdo-button tdo-save"
                style="margin-right: 10px;">
                @if (isLoading) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
                Submit Charges
              </button>
              <button type="button" mat-button
                (click)="onCancel()"
                class="tdo-button tdo-close"
                style="margin-right: 10px;">
                Cancel
              </button>
            </div>
          </div>
        </div>
